export { default } from './BenefitSlider';
